<template>
    <g>
        <path
            :fill="iconFill"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.86128 8.02851C3.12163 7.76816 3.54374 7.76816 3.80409 8.02851L7.33268 11.5571L7.33268 3.83325C7.33268 3.46506 7.63116 3.16658 7.99935 3.16658C8.36754 3.16658 8.66602 3.46506 8.66602 3.83325L8.66602 11.5571L12.1946 8.02851C12.455 7.76816 12.8771 7.76816 13.1374 8.02851C13.3978 8.28886 13.3978 8.71097 13.1374 8.97132L8.47075 13.638C8.2104 13.8983 7.78829 13.8983 7.52795 13.638L2.86128 8.97132C2.60093 8.71097 2.60093 8.28886 2.86128 8.02851Z"
        />
    </g>
</template>
<script>
export default {
    name: "ArrowDown1617",
    props: {
        iconFill: {
            type: String,
            default: "#6F7287",
        },
    },
};
</script>
